// import { filter } from 'lodash';

let CancelToken;
let source;

const Config = require('~/config/default.env').default;

export default {
  namespaced: true,
  state: {
    isLoadingFinish: {
      tryThisProducts: false,
    },
    tryProducts: {
      data: [],
      loading: true,
    },
    product: [],
    loading: true,
    total_product: 0,
    brand: [],
    brand_origin: [],
    popular_brand: {
      data: [],
      loading: true,
    },
    categories: {
      data: '',
      loading: '',
    },
    popular_review: {
      data: [],
      loading: '',
    },
    parent: '',
    grandParent: '',
    grandParentId: '',
    tag: '',
    tagName: '',
    productYouLove: {
      data: [],
      loading: true,
    },
  },
  mutations: {
    SET_LOAD_PRODUCT(state, data) {
      state.loading = data;
    },
    SET_DATA_CATEGORY(state, data) {
      state.categories.data = data;
    },
    SET_DATA_BRAND(state, data) {
      state.brand = data;
    },
    SET_DATA_BRAND_ORIGIN(state, data) {
      state.brand_origin = data;
    },
    SET_PRODUCT(state, data) {
      state.product = data;
    },
    SET_LOAD_CATEGORY(state, data) {
      state.categories.loading = data;
    },
    SET_POPULAR_BRAND(state, data) {
      state.popular_brand.data = data;
    },
    SET_LOAD_POPULAR_BRAND(state, data) {
      state.popular_brand.loading = data;
    },
    SET_TOTAL_PRODUCT(state, data) {
      state.total_product = data;
    },
    SET_POPULAR_REVIEW(state, data) {
      state.popular_review.data = data;
    },
    SET_LOAD_POPULAR_REVIEW(state, data) {
      state.popular_review.loading = data;
    },
    MERGE_PRODUCT(state, data) {
      state.product = state.product.concat(data);
    },
    SET_GRANDPARENT_ID(state, data) {
      state.grandParentId = data;
    },
    SET_GRANDPARENT_DATA(state, { dataGrandParent, dataParent }) {
      dataGrandParent.listParent = dataParent;

      this._vm.$SO.each(dataGrandParent.listParent, (key, category) => {
        dataGrandParent.listParent[key].showNestedList = false;

        if (state.categories.data.my_soco_sql_id === category.my_soco_sql_id) {
          dataGrandParent.listParent[key].showNestedList = true;
        }

        this._vm.$SO.each(category.sub_categories, (keySubcategory, subcategory) => {
          if (state.categories.data.my_soco_sql_id === subcategory.my_soco_sql_id) {
            dataGrandParent.listParent[key].showNestedList = true;
          }
        });
      });

      state.grandParent = dataGrandParent;
    },
    SET_PARENT_DATA(state, data) {
      state.parent = data;
    },
    SET_TAGS(state, data) {
      state.tag = data;
    },
    SET_TAGS_NAME(state, data) {
      state.tagName = data;
    },
    SET_PRODUCT_YOU_LOVE(state, data) {
      state.productYouLove.data = data;
    },
    SET_PRODUCT_YOU_LOVE_LOADING(state, data) {
      state.productYouLove.loading = data;
    },
    product_try(state, { data, merge = false }) {
      if (merge) {
        const deduplicateData = state.tryProducts.concat(
          data.filter((newData) => !state.tryProducts.find((firstData) => firstData._id == newData._id))
        );
        state.tryProducts = deduplicateData;
      } else {
        state.tryProducts = data;
      }
    },
    SET_TRENDING_REVIEW(state, data) {
      state.tryProducts.data = data;
    },
  },
  actions: {
    getPopularBrands({ state, dispatch, commit }, categoryId) {
      return axios
        .get(`${Config.MS_CATALOG_API_URL}/v3/categories/${categoryId}/featured-brand`)
        .then((response) => {
          if (response.status === 200) {
            const datas = response.data.data;
            commit('SET_POPULAR_BRAND', datas);
            commit('SET_LOAD_POPULAR_BRAND', false);
          } else {
            commit('SET_POPULAR_BRAND', []);
            commit('SET_LOAD_POPULAR_BRAND', false);
          }
        })
        .catch((err) => {
          commit('SET_POPULAR_BRAND', []);
          commit('SET_LOAD_POPULAR_BRAND', false);
        });
    },
    async getCategoryDetail({ rootState, state, dispatch, commit }, categoryId) {
      const filter = {
        my_soco_sql_id: categoryId,
      };
      return new Promise((resolve, reject) => {
        try {
          resolve(
            this._vm.$MS_SOCO_PUBLIC_API_URL.get('/product/categories', {
              params: {
                filter,
              },
            })
          );
        } catch (error) {
          reject(error);
        }
      })
        .then(({ data }) => {
          const datas = data.data[0];
          const totalParents = this._vm.$SO.size(datas.parents);
          let grandParentId = '';
          let idCurrentParrent = '';
          if (totalParents <= 1) {
            grandParentId = categoryId;
          } else {
            const getParent = (rootState.header.categoriesOfDepartment || []).find(
              (x) => datas.parents.indexOf(x._id) > -1
            );
            if (getParent && this._vm.$SO.size(getParent)) {
              grandParentId = getParent.my_soco_sql_id;
              idCurrentParrent = getParent._id;
            } else {
              grandParentId = categoryId;
            }
          }
          commit('SET_GRANDPARENT_ID', grandParentId);
          if (
            !this._vm.$SO.size(state.grandParent) ||
            state.grandParent.my_soco_sql_id.toString() !== grandParentId.toString()
          ) {
            dispatch('getGrandParent', {
              grandParentId: idCurrentParrent,
              isFetchGetParent: true,
            });
          }
          commit('SET_DATA_CATEGORY', datas);
          dispatch('getPopularBrands', datas._id);
          dispatch('getDistinctBrands', datas.my_soco_sql_id);
          dispatch('getPopularReview', datas._id);
          dispatch('getTryThisProducts', datas._id);
          dispatch('getProductsTotal', datas._id);
          commit('SET_LOAD_CATEGORY', false);
        })
        .catch((err) => {
          commit('SET_DATA_CATEGORY', '');
          commit('SET_LOAD_CATEGORY', false);
        });
    },
    getGrandParent({ commit, state, dispatch }, { grandParentId, isFetchGetParent = false }) {
      //new api
      this._vm.$MS_CATALOG_API_URL
        .get(`/v3/categories/children`, {
          params: {
            filter: {
              _id: grandParentId,
              depth: 3,
            },
            fields:
              'name,my_soco_sql_id,my_sociolla_sql_id,link_rewrite,parents,slug,banner_for_sociolla,logo,is_featured',
            skip: 0,
            limit: 10,
            sort: 'position',
          },
        })
        .then((response) => {
          if (response.status === 200) {
            const data = response.data.data;
            commit('SET_GRANDPARENT_DATA', {
              dataGrandParent: data,
              dataParent: data.children,
            });
            dispatch('getTags');
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProductsTotal({ commit, state, dispatch, rootState, rootGetters }, categoryId) {
      if (typeof source !== 'undefined') {
        source.cancel(false);
      }
      CancelToken = axios.CancelToken;
      source = CancelToken.source();
      const filter = {
        'categories.id': categoryId,
        is_deleted: false,
      };

      const params = {
        filter,
        section: 'getProductsTotal',
      };

      if (rootState.$_Review.queryString.sort) {
        params.sort = rootState.$_Review.queryString.sort;
      }

      if (rootState.$_Review.queryString.brands) {
        params.filter['brand.id'] = {
          $in: rootState.$_Review.queryString.brands.split(','),
        };
      }
      if (rootState.$_Review.queryString.tags) {
        params.filter['tags.id'] = {
          $in: rootState.$_Review.queryString.tags.split(','),
        };
      }

      if (rootState.$_Review.queryString.origins) {
        params.filter['brand.country_tag_id'] = {
          $in: rootState.$_Review.queryString.origins.split(','),
        };
      }

      if (rootState.$_Review.queryString.category) {
        params.filter['categories.id'] = {
          $in: rootState.$_Review.queryString.category,
        };
      }

      if (rootState.$_Review.queryString.available_for) {
        if (
          rootState.$_Review.queryString.available_for.includes('sociolla') &&
          rootState.$_Review.queryString.available_for.includes('lulla')
        ) {
          params.filter['is_active_in_sociolla'] = true;
          params.filter['is_active_in_lulla'] = true;
        } else if (rootState.$_Review.queryString.available_for.includes('lulla')) {
          params.filter['is_active_in_lulla'] = true;
          params.filter['is_active_in_sociolla'] = false;
        } else {
          params.filter['is_active_in_sociolla'] = true;
          params.filter['is_active_in_lulla'] = false;
        }
      }

      if (rootState.$_Review.queryString.rating) {
        const filterQuery = rootState.$_Review.queryString.rating.split(',') || [];
        const rating = [];
        filterQuery.map((x) => {
          const intRating = Number(x);
          if (filterQuery.length > 1) {
            rating.push({
              'review_stats.average_rating': {
                $gte: intRating,
                $lte: intRating + 0.999,
              },
            });
          } else {
            rating.push({
              'review_stats.average_rating': { $gte: intRating },
            });
            rating.push({
              'review_stats.average_rating': { $lte: intRating + 0.999 },
            });
          }
        });
        if (filterQuery.length > 1) {
          params.filter['$and'] = [{ $or: rating }];
        } else {
          params.filter['$and'] = rating;
        }
      }

      const paramSearch = { params: params, cancelToken: source.token };
      return axios
        .get(`${Config.MS_CATALOG_API_URL}/search/count`, paramSearch)
        .then((response) => {
          const datas = response.data.data;
          commit('SET_TOTAL_PRODUCT', datas);
          if (datas > 0) {
            dispatch('getProducts', categoryId);
          } else {
            commit('SET_PRODUCT', []);
            commit('SET_LOAD_PRODUCT', false);
          }
        })
        .catch((err) => {
          commit('SET_TOTAL_PRODUCT', 0);
          commit('SET_PRODUCT', []);
          commit('SET_LOAD_PRODUCT', false);
        });
    },
    getProducts({ commit, state, dispatch, rootState, rootGetters }, categoryId) {
      try {
        const filter = {
          'categories.id': categoryId,
          is_deleted: false,
        };

        const params = {
          filter,
          limit: rootState.$_Review.queryString.limit,
          skip: rootState.$_Review.queryString.skip,
          sort: '-review_stats.total_reviews',
        };

        if (rootState.$_Review.queryString.sort) {
          params.sort = rootState.$_Review.queryString.sort;
        }

        if (rootState.$_Review.queryString.brands) {
          params.filter['brand.id'] = {
            $in: rootState.$_Review.queryString.brands.split(','),
          };
        }
        if (rootState.$_Review.queryString.tags) {
          params.filter['tags.id'] = {
            $in: rootState.$_Review.queryString.tags.split(','),
          };
        }

        if (rootState.$_Review.queryString.origins) {
          params.filter['brand.country_tag_id'] = {
            $in: rootState.$_Review.queryString.origins.split(','),
          };
        }

        if (rootState.$_Review.queryString.category) {
          params.filter['categories.id'] = {
            $in: rootState.$_Review.queryString.category,
          };
        }

        if (rootState.$_Review.queryString.rating) {
          const filterQuery = rootState.$_Review.queryString.rating.split(',') || [];
          const rating = [];
          filterQuery.map((x) => {
            const intRating = Number(x);
            if (filterQuery.length > 1) {
              rating.push({
                'review_stats.average_rating': {
                  $gte: intRating,
                  $lte: intRating + 0.999,
                },
              });
            } else {
              rating.push({
                'review_stats.average_rating': { $gte: intRating },
              });
              rating.push({
                'review_stats.average_rating': { $lte: intRating + 0.999 },
              });
            }
          });
          if (filterQuery.length > 1) {
            params.filter['$and'] = [{ $or: rating }];
          } else {
            params.filter['$and'] = rating;
          }
        }

        if (rootState.$_Review.queryString.available_for) {
          if (
            rootState.$_Review.queryString.available_for.includes('sociolla') &&
            rootState.$_Review.queryString.available_for.includes('lulla')
          ) {
            params.filter['is_active_in_sociolla'] = true;
            params.filter['is_active_in_lulla'] = true;
          } else if (rootState.$_Review.queryString.available_for.includes('lulla')) {
            params.filter['is_active_in_lulla'] = true;
            params.filter['is_active_in_sociolla'] = false;
          } else {
            params.filter['is_active_in_sociolla'] = true;
            params.filter['is_active_in_lulla'] = false;
          }
        }

        const paramSearch = { params: params, cancelToken: source.token };
        return axios
          .get(`${Config.MS_CATALOG_API_URL}/search`, paramSearch)
          .then((response) => {
            if (response.status === 200) {
              const datas = response.data.data;
              commit('SET_PRODUCT', datas);
              commit('SET_LOAD_PRODUCT', false);
            }
          })
          .catch((err) => {
            commit('SET_PRODUCT', []);
            commit('SET_LOAD_PRODUCT', false);
          });
      } catch (error) {
        commit('SET_PRODUCT', []);
        commit('SET_LOAD_PRODUCT', false);
        console.error('Error in getProducts:', error);
      }
    },
    async getDistinctBrands({ state, dispatch, commit }, keyword) {
      return new Promise((resolve, reject) => {
        try {
          resolve(
            this._vm.$MS_SOCO_PUBLIC_API_URL.get(`/product/categories/${keyword}/brands`, {
              params: {
                fields: 'my_soco_sql_id name logo country flag country_tag_id',
                sort: 'name',
                limit: 0, // unlimited
                filter: {
                  is_active_in_review: true,
                },
              },
            })
          );
        } catch (error) {
          reject(error);
          this.isLoadingFinishBrandsConjunctionWithCategory = true;
          commit('SET_DATA_BRAND', []);
          commit('SET_DATA_BRAND_ORIGIN', []);
        }
      }).then(({ data }) => {
        const results = data.data;
        commit('SET_DATA_BRAND', results);
        const listBrand = data.data;
        const result = [];
        const map = new Map();
        for (const item of listBrand) {
          if (item.country && item.country_tag_id && !map.has(item.country)) {
            map.set(item.country, true);
            result.push(item);
          }
        }
        commit(
          'SET_DATA_BRAND_ORIGIN',
          result.sort((a, b) => a.country.localeCompare(b.country))
        );
      });
    },
    getPopularReview({ commit, state, dispatch, rootState, rootGetters }, categoryId) {
      return axios
        .get(`${Config.MS_REVIEW_API_URL}/reviews/category/${categoryId}/popular/`)
        .then((response) => {
          if (response.status === 200) {
            const datas = response.data.data;
            commit('SET_POPULAR_REVIEW', datas);
            commit('SET_LOAD_POPULAR_REVIEW', false);
          }
        })
        .catch((err) => {
          commit('SET_POPULAR_REVIEW', []);
          commit('SET_LOAD_POPULAR_REVIEW', false);
        });
    },
    getTags({ commit, state, dispatch, rootState, rootGetters }) {
      let isHair = false;
      if (state.grandParent && state.grandParent.name && state.grandParent.name.toLowerCase() === 'hair care') {
        isHair = true;
      }
      const params = {
        skip: 0,
        limit: 0,
        sort: 'created_at',
        filter: {
          level_name: { $in: ['Skin/Hair Type', 'Concern'] },
          is_filter: true,
        },
        fields: '_id name level_name',
      };
      return axios
        .get(`${Config.MS_CATALOG_API_URL}/tags`, {
          params: params,
        })
        .then((response) => {
          if (response.status === 200 && response.data.data) {
            let list = response.data.data;
            if (isHair) {
              list = response.data.data.filter((x) => x.name.toLowerCase().includes('rambut'));
            } else {
              list = response.data.data.filter((x) => !x.name.toLowerCase().includes('rambut'));
            }
            const listName = list.map((lists) => lists.name);
            commit('SET_TAGS', list);
            commit('SET_TAGS_NAME', listName);
            dispatch('getProductYouLove', {
              categoryId: state.categories.data._id,
              listBeautyProfile: listName,
            });
          }
        })
        .catch((err) => {
          commit('SET_TAGS', '');
        });
    },
    getTryThisProducts({ state, commit }, categoryId) {
      this._vm.$MS_SOCO_PUBLIC_API_URL
        .get(`/products/featured/have-you-tried`, {
          params: {
            filter: {
              is_reviewed: true,
              ...(categoryId && { 'categories.id': categoryId }),
            },
            skip: 0,
            limit: 10,
            section: 'haveYouTriedProducts',
            fields:
              'active brand default_category discount_type id images la_ps_product_id_product max_price min_price name has_bookmarked price price_after_discount review_stats total_reviews parent_category is_reviewed',
          },
        })
        .then((response) => {
          if (response.status === 200 && response.data.data) {
            const response_data = response.data.data;
            if (state.tryProducts && state.tryProducts.length) {
              commit('product_try', { data: response_data, merge: true });
            } else {
              commit('product_try', { data: response_data });
            }
          } else {
            commit('product_try', { data: [] });
          }
          commit('SET_TRENDING_REVIEW', true);
        })
        .catch((err) => {
          commit('SET_TRENDING_REVIEW', true);
          commit('product_try', { data: [] });
        });
    },
    getProductYouLove({ commit, state, dispatch, rootState, rootGetters }, { categoryId, listBeautyProfile }) {
      const params = {
        limit: 10,
        skip: 0,
        filter: {
          'categories.id': categoryId,
          is_in_stock: true,
          is_reviewed: true,
          is_active_in_review: true,
          is_you_might_love: true,
          'tags.name': { $in: listBeautyProfile },
        },
      };
      return axios
        .get(`${Config.MS_SOCO_PUBLIC_API_URL}/products`, {
          params: params,
        })
        .then((response) => {
          if (response.status === 200 && response.data.data) {
            const list = response.data.data;
            commit('SET_PRODUCT_YOU_LOVE', list);
            commit('SET_PRODUCT_YOU_LOVE_LOADING', false);
          }
        })
        .catch((err) => {
          commit('SET_PRODUCT_YOU_LOVE', '');
          commit('SET_PRODUCT_YOU_LOVE_LOADING', false);
        });
    },
    loadMoreProducts({ commit, state, dispatch, rootState, rootGetters }, categoryId) {
      if (typeof source !== 'undefined') {
        source.cancel(false);
      }
      CancelToken = axios.CancelToken;
      source = CancelToken.source();
      const filter = {
        'categories.id': categoryId || state.categories.data._id,
        is_deleted: false,
        is_active_in_review: true,
      };

      const params = {
        filter,
        limit: rootState.$_Review.queryString.limit,
        skip: rootState.$_Review.queryString.skip,
        sort: '-review_stats.total_reviews',
      };

      if (rootState.$_Review.queryString.sort) {
        params.sort = rootState.$_Review.queryString.sort;
      }

      if (rootState.$_Review.queryString.brands) {
        params.filter['brand.id'] = {
          $in: rootState.$_Review.queryString.brands.split(','),
        };
      }

      if (rootState.$_Review.queryString.tags) {
        params.filter['tags.id'] = {
          $in: rootState.$_Review.queryString.tags.split(','),
        };
      }

      if (rootState.$_Review.queryString.origins) {
        params.filter['brand.country_tag_id'] = {
          $in: rootState.$_Review.queryString.origins.split(','),
        };
      }

      if (rootState.$_Review.queryString.category) {
        params.filter['categories.id'] = {
          $in: rootState.$_Review.queryString.category,
        };
      }

      if (rootState.$_Review.queryString.rating) {
        const filterQuery = rootState.$_Review.queryString.rating.split(',') || [];
        const rating = [];
        filterQuery.map((x) => {
          const intRating = Number(x);
          if (filterQuery.length > 1) {
            rating.push({
              'review_stats.average_rating': {
                $gte: intRating,
                $lte: intRating + 0.999,
              },
            });
          } else {
            rating.push({
              'review_stats.average_rating': { $gte: intRating },
            });
            rating.push({
              'review_stats.average_rating': { $lte: intRating + 0.999 },
            });
          }
        });
        if (filterQuery.length > 1) {
          params.filter['$and'] = [{ $or: rating }];
        } else {
          params.filter['$and'] = rating;
        }
      }

      if (rootState.$_Review.queryString.available_for) {
        if (
          rootState.$_Review.queryString.available_for.includes('sociolla') &&
          rootState.$_Review.queryString.available_for.includes('lulla')
        ) {
          params.filter['is_active_in_sociolla'] = true;
          params.filter['is_active_in_lulla'] = true;
        } else if (rootState.$_Review.queryString.available_for.includes('lulla')) {
          params.filter['is_active_in_lulla'] = true;
          params.filter['is_active_in_sociolla'] = false;
        } else {
          params.filter['is_active_in_sociolla'] = true;
          params.filter['is_active_in_lulla'] = false;
        }
      }

      const paramSearch = { params: params, cancelToken: source.token };
      return axios
        .get(`${Config.MS_CATALOG_API_URL}/search`, paramSearch)
        .then((response) => {
          if (response.status === 200) {
            const datas = this._vm.$get(response, 'data.data', []);
            commit('MERGE_PRODUCT', datas);
          } else {
            commit('MERGE_PRODUCT', []);
          }
          return response;
        })
        .catch((err) => {
          commit('MERGE_PRODUCT', []);
          return err;
        });
    },
  },
};
